import { extendTheme } from '@chakra-ui/react';
import {
  ASSET_COLOR,
  BG_ALTERNATIVE,
  BG_LAYER,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';
import { COLORS } from '@/constants/design-tokens';

const theme = {
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
    /*
      OFF, AND IT IS LOAD-BEARING — THIS IS WHAT LETS ANY CSS TRANSITION RUN
      AT ALL IN THIS TEMPLATE.

      Chakra's colour-mode provider wraps every mode change in
      `preventTransition()`, which appends a `<style>` containing

          * { transition: none !important }

      to the head and removes it two `requestAnimationFrame`s later, so the
      change itself does not visibly animate. Sensible in isolation.

      It goes wrong here because this template FORCES light: `pages/index.jsx`
      installs a manager whose `get` always returns 'light' and whose `set` is a
      no-op, while the config above declares 'dark'. The provider therefore
      keeps trying to reconcile a mode that never sticks, and each attempt
      appends another one of those style tags. Measured on the running page:
      FOUR of them, in no media query, still present long after load. Every CSS
      transition on the invitation was being suppressed — the gallery's
      hover-focus blur and the photo-gallery quote's blur reveal both computed
      to `transition-property: none` and simply snapped.

      That failure is invisible in source: each component's transition is
      written correctly and loses to `!important` on a universal selector from a
      stylesheet nobody wrote. The tell is `getComputedStyle(el).transition`
      reading `none` on an element whose CSS clearly sets one.

      Turning this off means Chakra never injects the tag. Nothing is lost: the
      mode is pinned to light, so there is no colour-mode change for it to
      smooth over in the first place.
    */
    disableTransitionOnChange: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    /** the serif-italic voice; see TEXT_PROPS.accent */
    accent: FONT_FAMILY.accent,
    /**
     * `jost` and `delafield` are inherited names still referenced by common
     * components. Both are repointed at self-hosted faces: this design ships
     * no sans face, and requesting either from a CDN would fail the
     * build-verification script's no-third-party-font assertion.
     */
    jost: FONT_FAMILY.accent,
    delafield: FONT_FAMILY.subHeading,
  },
  fontSizes: {
    heading: '30px',
    subHeading: '58px',
    body: '16px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    backgroundAssetColor: BG_LAYER,
    mainAssetColor: ASSET_COLOR,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
  },
  styles: {
    /**
     * The page backdrop. Every section is transparent so the pinned video
     * shows through, which means the document itself is what a guest sees
     * before the video paints and behind any gap — so it must be the
     * palette's deepest shadow, never white.
     */
    global: {
      'html, body': {
        backgroundColor: COLORS.shadow,
        color: COLORS.text,
      },
    },
  },
};

export default extendTheme(theme);
